import React from 'react'
import { getAdId } from '../../../../utils/ads'

const CCardAd = () => {
  const adId = getAdId('mediumRectangle')

  return (
    <div className="c-CardAd">
      <div className="c-CardAd-card dfb-Card">{adId && <div id={adId} className="c-CardAd-slot"></div>}</div>
      <div className="c-CardAd-hint">Werbung</div>
    </div>
  )
}

export default CCardAd
